<template>
	<div class="container-wrap">
		<div class="container">
			<div class="aside">
				<asideVideo :current="curNameId" :isAll="isAll" :isShowAll="true" @toList="toList" :menuList="menuList"/>
			</div>
			<div class="content">
				<ul class="content-list">
					<li v-for="item in dataList">
						<div class="list-left">
							<div class="list-title">
								<span class="list-btn" v-if="item.topFlag">置顶</span>
								<h3 :class="[item.topFlag?'':'padding0']">{{item.title}}</h3>
								<span class="recommend-btn" v-if="item.recommendFlag">推荐</span>
							</div>
							<div class="list-desc">
								{{item.introduction}}
							</div>
							<div class="list-tips">
								<div class="down-list-file" @click="toFile(item)">
									<img src="@/assets/document_icon.png" />
									<span>说明文档</span>
								</div>
								<span class="list-time">上线时间：{{item.addTime | datefmt('yyyy-MM-DD')}}</span>
							</div>
						</div>
						<a class="download" href="javascript:;" @click="toDown(item.picUrl)">下载</a>
					</li>
				</ul>
				<div class="pagination-wrap">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :page-size= this.pageSize
					  :total=this.total
					  @current-change="handleCurrentChange"
					  hide-on-single-page
					  >
					</el-pagination>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'
	import asideVideo from '@/components/product/asideVideo'
	import { post, config, ajaxParam } from '@/units/request.js'
	export default {
		name: 'Home',
		components: {
			asideVideo
		},
		data() {
			return {
				currentMenu: 0,
				menuList: [],
				id: '',
				categoryIdOne: '',
				categoryIdTwo: '',
				dataList: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
				curNameId: 0,
				userId: '',
				isAll: true
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
			let id = this.$route.params.id
			this.id = id
			this.getCateList()
		},
		watch: {
			$route(to,from) {
				let id = this.$route.params.id
				this.id = id
				this.categoryIdOne = ''
				this.categoryIdTwo = ''
				this.curNameId = 0
				this.pageNum = 1
				this.total = 0
				this.isAll = true
				this.getCateList()
			}
		},
		methods: {
			//获取新闻类型
			async getCateList(){
				let param = {
					id: this.id,
					typeCode: 'down'
				}
				ajaxParam(param)
				const res = await post('v1/category/tree', qs.stringify(param))
				if(res.data.code==200){
					console.log('----3')
					console.log(res)
					let list = res.data.list
					for(var i=0; i<list.length; i++){
						list[i].isShowChild = true
					}
					this.menuList = list
					this.getDataList()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取当前列表数据
			async getDataList(){
				let param = {
					categoryIdOne: this.categoryIdOne,
					categoryIdTwo: this.categoryIdTwo,
					columnId: this.id,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/download/list', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e
				this.getDataList()
			},
			toList(e){
				this.curNameId = e.id
				console.log(e)
				if(e.parentId) {
					this.categoryIdOne = e.parentId
					this.categoryIdTwo = e.id
				} else{
					this.categoryIdOne = e.id
					this.categoryIdTwo = ''
				}
				if(e.isAll) {
					this.categoryIdOne = ''
					this.categoryIdTwo = ''
				}
				this.isAll = e.isAll
				this.pageNum = 1
				this.total = 0
				this.getDataList()
			},
			toFile(item){
				let url = config.baseUrl+item.documentUrl
				console.log(url)
				window.open(url)
			},
			toDown(picUrl){
				// if(!this.userId){
				// 	this.$router.push({
				// 		path: '/login'
				// 	})
				// 	return
				// }
				window.open(picUrl)
			}
		}
	}
</script>
<style scoped lang="less">
	.container{
		padding: 26px 0 10px;
		.aside{
			float: left;
			width: 280px;
			height: 400px;
			background: #fff;
			.menu{
				li{
					height: 44px;
					padding: 0 23px;
					line-height: 44px;
				}
				li.active{
					background: rgba(222, 5, 21,.1);
					border-right: 4px solid #DE0515;
					color: #000
				}
			}
		}
		.content{
			float: right;
			width: 880px;
			min-height: 480px;
			background:#fff;
			padding-top: 0;
			padding-bottom: 15px;
			.content-list{
				li{
					display: flex;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid #e7e8eb;
					padding: 18px 24px;
					.list-title{
						position: relative;
						display: flex;
						align-items: center;
						margin-bottom: 9px;

						text-overflow: ellipsis;
						white-space: nowrap;
						word-break: break-all;
						word-wrap: break-word;
						span.list-btn{
							display: inline-block;
							padding: 1px 8px;
							margin-right: 7px;
							font-size: 12px;
							border-radius: 3px;
							background-color: #fff;
							border: 1px solid #1075e7;
							color: #1075e7;
							user-select: none;
							cursor: pointer;
							text-align: center;
							line-height: 18px;
							position: absolute;
							left: 0;
							top: 2px;
						}
						h3{
							padding-left: 46px;
							overflow: hidden;
							font-size: 18px;
							line-height: 26px;
							white-space: normal;
						}
						h3.padding0{
							padding-left: 0
						}
						.recommend-btn{
							margin: 0 7px;
							font-size: 12px;
							color: #1075e7;
						}
					}
					.list-left{
						flex: 1;
					}
					.list-desc{
						margin-bottom: 12px;
						color: #404040;
						text-align: justify;
						line-height: 18px;
						font-size: 12px;
					}
					.list-tips{
						display: flex;
						font-size: 12px;
						.down-list-file{
							display: flex;
							align-items: center;
							cursor: pointer;
							img{
								width: 16px;
								height: 16px;
								margin-right: 2px;
							}
							span {
								color: #1075e7;
							}
						}
						.list-time{
							margin-left: 18px;
							color: #768096;
						}
					}
					.download{
						width: 100px;
						height: 32px;
						margin-left: 30px;
						border: 1px solid #1075e7;
						border-radius: 5px;
						color: #1075e7;
						line-height: 32px;
						text-align: center;
						cursor: pointer;
					}
				}
				li:hover{
					position: relative;
					box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
					border-radius: 6px;
					z-index: 1
				}
			}
		}
	}
</style>
